<template>
  <div class="experience-filter filters-container">
    <select-filter
      type="experience"
      field="status"
      label="Статус"
      request="objectInfo/contract_statuses"
      :parse-value="({ name }) => name"
      :multiple="true"
      size="default"
      :disabled="!!tableLoading"
    />
    <sorting-control
      style="margin-left: 16px;"
      type="experience"
      :values="sortingFields"
      size="default"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'

const sortingFields = [
  { field: 'code', name: 'Шифр' },
  { field: 'start_date', name: 'Год начала' },
  { field: 'end_date', name: 'Год окончания' }
]

export default {
  components: {
    SelectFilter,
    SortingControl
  },
  computed: {
    tableLoading () {
      return this.$store.state.experience.tableLoading
    }
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style lang="less">
.experience-filter {
  .select-filter {
    .ivu-select {
      width: 620px !important;
    }
  }
}
</style>
